import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ConfigStateService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';

export const coachProfileInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const configState = inject(ConfigStateService);
  const toaster = inject(ToasterService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Check if it's the specific coach registration error
      if ((error.status === 403 || error.status === 400) && 
          (error.error?.error?.message === 'YouAreNotRegisteredAsCoach' ||
           error.error?.error?.message === 'You are not registered as a coach. Please complete your coach profile first.' ||
           error.error?.error?.message === 'Koç olarak kayıtlı değilsiniz. Lütfen önce koç profilinizi tamamlayın.')) {
        
        // Check if user has coach permission
        const auth = configState.getOne('auth');
        if (auth?.grantedPolicies?.['Io.Coaches.ManageOwnStudents']) {
          
          // Show message and redirect to profile completion
          try {
            toaster.warn(
              'Koç profilinizi tamamlamanız gerekmektedir. Yönlendiriliyorsunuz...', 
              'Profil Tamamlama Gerekli'
            );
          } catch (e) {
            console.warn('ToasterService error:', e);
          }
          
          // Navigate immediately
          router.navigate(['/coach/profile-completion']);
          
          // Prevent the original error from being shown
          return throwError(() => new Error('Redirecting to profile completion'));
        }
      }
      
      // For all other errors, pass them through
      return throwError(() => error);
    })
  );
};